<div style="height: 100%">
  <as-split direction="vertical">
    <as-split-area>
      <as-split #splitRef direction="horizontal">
        <as-split-area>
          <ng-content></ng-content>
        </as-split-area>
        @for (component of horizontalComponents; track component) {
        <as-split-area [size]="component.size" class="split-area-header">
          @if(component.header) {
          <div class="component-header">
            @if(component.header.closeButton) {
            <button mat-icon-button color="primary" (click)="onClose(component)">
              <mat-icon>close</mat-icon>
            </button>
            }
          </div>
          }
          <div class="component-content">
            <ng-container *ngTemplateOutlet="splitter; context: { component }"></ng-container>
          </div>
        </as-split-area>
        }
      </as-split>
    </as-split-area>
    @for (component of verticalComponents; track component) {
    <as-split-area [size]="component.size">
      <div class="component-content">
        <ng-container *ngTemplateOutlet="splitter; context: { component }"></ng-container>
      </div>
    </as-split-area>
    }
  </as-split>
</div>

<ng-template #splitter let-component="component">
  @if(component.children?.length) {
  <app-split-wrapper [dynamicComponents]="component.children">
    <ng-template appDynamicComponentHost [dynamicComponent]="component"></ng-template>
  </app-split-wrapper>
  } @else {
  <ng-template appDynamicComponentHost [dynamicComponent]="component"></ng-template>
  }
</ng-template>
